import rill from "rill";
import set from "@rill/set";
import NutritionController from "./nutrition.controller";

const Nutrition = (app) => {
  app.at(
    "/nutrition/*",
    rill()
      .use(set("heading", ["Athlete", "Nutrition"]))
      .setup(NutritionController)
  );
};

export default Nutrition;
